
export default {
  name: 'WarningProductBadge',
  props: {
    warnings: String,
    small: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expandWarning: false,
    }
  },
}
